/**
 * Global "New card" dialog host — DESIGN.md §13.5, Long-Day Review DAILY-2.
 *
 * Mounted once at the root, it listens for the `new-card` UI event (see
 * lib/ui-events.ts) so `c`, the project header, the sidebar and the ⌘K palette
 * all open the same dialog from any screen — with whatever scope the caller
 * knew about (a project, a section) already filled in.
 *
 * The dialog is keyed by the opening, so every opening starts clean rather
 * than resurrecting the last one's half-typed title.
 */
import { useEffect, useState } from 'react';
import { onUi } from '@/lib/ui-events';
import { NewCardDialog, type NewCardTarget } from './new-card-dialog';

export function NewCardHost(): JSX.Element | null {
  const [opening, setOpening] = useState<{ seq: number; target: NewCardTarget } | null>(null);

  useEffect(
    () =>
      onUi('new-card', (detail) => {
        setOpening((current) => ({ seq: (current?.seq ?? 0) + 1, target: detail ?? {} }));
      }),
    [],
  );

  if (!opening) return null;

  return (
    <NewCardDialog
      key={opening.seq}
      open
      onOpenChange={(next) => {
        if (!next) setOpening(null);
      }}
      target={opening.target}
    />
  );
}
